import { useTranslation } from 'react-i18next';
import { RatiosTab } from './RatiosTab';

export function GlobalRatiosPage() {
  const { t } = useTranslation('ratios');
  return (
    <div style={{ padding: 32, maxWidth: 1200 }}>
      <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 28, marginBottom: 8 }}>
        {t('title', 'Ratios & Sources')}
      </h1>
      <p style={{ color: 'var(--color-text-muted)', fontSize: 14, marginBottom: 24 }}>
        {t('globalDescription', 'Manage global ratios and benchmark costs applied across all projects.')}
      </p>
      <RatiosTab />
    </div>
  );
}
